import { FC } from 'react'
import {
  AutocompleteInput,
  ReferenceInput,
  required,
  SelectInput,
  useTranslate
} from 'react-admin'

const CreatePartnerForm: FC = () => {
  const translate = useTranslate()

  return (
    <>
      <ReferenceInput label="data.partner" source="formValues.partnerId" reference="organisaties">
        <AutocompleteInput optionText="naam" optionValue="id" />
      </ReferenceInput>

      <SelectInput
        source="formValues.privilege"
        label={'data.access'}
        choices={[
          { id: 'VT', name: translate('data.privilegeVT') },
          { id: 'BT', name: translate('data.privilege') }
        ]}
        optionText="name"
        optionValue="id"
        defaultValue="BT"
        validate={required()}
      />
    </>
  )
}

export default CreatePartnerForm
